// 本地存储键名
const WALLET_ADDRESS_KEY = 'kingSwap_wallet_address'
const WALLET_CHAIN_ID_KEY = 'kingSwap_chain_id'

// 获取本地存储的钱包地址
export const getStoredWalletAddress = (): string | null => {
  try {
    return localStorage.getItem(WALLET_ADDRESS_KEY)
  } catch (error) {
    return null
  }
}

// 存储钱包地址到本地
export const storeWalletAddress = (address: string, chainId: number): void => {
  try {
    localStorage.setItem(WALLET_ADDRESS_KEY, address)
    localStorage.setItem(WALLET_CHAIN_ID_KEY, chainId.toString())
  } catch (error) {
    // Failed to store wallet address
  }
}

// 清除本地存储的钱包地址
export const clearStoredWalletAddress = (): void => {
  try {
    localStorage.removeItem(WALLET_ADDRESS_KEY)
    localStorage.removeItem(WALLET_CHAIN_ID_KEY)
  } catch (error) {
    // Failed to clear stored wallet address
  }
}

// 获取存储的链ID
export const getStoredChainId = (): number | null => {
  try {
    const chainIdStr = localStorage.getItem(WALLET_CHAIN_ID_KEY)
    return chainIdStr ? parseInt(chainIdStr, 10) : null
  } catch (error) {
    return null
  }
}
